module.exports = __webpack_public_path__ + "media/images/front/icon_circle_question-6aa1cd119f0e0abbce38078073e6b8c4.svg";